import { translate } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { ConsentName } from '@gig/magic-sdk/dist/adapter/users/userPendingConsents';
import { MarketingSubConsentsName, getAllConsents } from '../utils/consents.js';

var _a;
var subConsentMapping = (_a = {},
    _a[MarketingSubConsentsName.EMAIL] = 'emailOptIn',
    _a[MarketingSubConsentsName.SMS] = 'smsOptIn',
    _a[MarketingSubConsentsName.CALL] = 'callOptIn',
    _a[MarketingSubConsentsName.POSTALMAIL] = 'postalMailOptIn',
    _a[MarketingSubConsentsName.NOTIFICATION] = 'pushNotificationOptIn',
    _a);
function nestedConsents() {
    var _this = this;
    return {
        id: 'userConsents',
        component: 'magic-corex-nested-marketing-preferences',
        isDataField: true,
        isStandAlone: true,
        preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
            var consents, translatedConsents;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAllConsents()];
                    case 1:
                        consents = _a.sent();
                        translatedConsents = consents.map(function (consent) {
                            var _a;
                            if (!consent.consentContents.header) {
                                consent.consentContents.header =
                                    getTranslatedCategoryHeader(consent.name);
                            }
                            if ((_a = consent.subConsents) === null || _a === void 0 ? void 0 : _a.length) {
                                consent.subConsents = consent.subConsents.map(function (sub) {
                                    if (!sub.consentContents.header) {
                                        sub.consentContents.header =
                                            getTranslatedSubConsent(sub.name);
                                    }
                                    return sub;
                                });
                            }
                            return consent;
                        });
                        return [2 /*return*/, {
                                consents: translatedConsents,
                            }];
                }
            });
        }); },
        converter: function (formValue) {
            var _a;
            var consents = ((_a = formValue.userConsents) === null || _a === void 0 ? void 0 : _a.value) || [];
            var privacy = consents.find(function (c) { return c.name === ConsentName.PRIVACY_COOKIE_POLICY; });
            var terms = consents.find(function (c) { return c.name === ConsentName.TERMS; });
            var productMarketingOptIn = {};
            consents.forEach(function (consent) {
                if (consent.subConsents && consent.subConsents.length > 0) {
                    var categoryKey_1 = consent.name.toLowerCase();
                    productMarketingOptIn[categoryKey_1] = initEmptyOptIn();
                    consent.subConsents.forEach(function (sub) {
                        console.log(sub.name);
                        console.log(subConsentMapping);
                        var apiField = subConsentMapping[sub.name.toUpperCase()] ||
                            subConsentMapping[sub.name];
                        if (apiField) {
                            productMarketingOptIn[categoryKey_1][apiField] =
                                !!sub.consented;
                        }
                    });
                }
            });
            return {
                termsAndConditionsVersion: terms === null || terms === void 0 ? void 0 : terms.version,
                privacyPolicyVersion: privacy === null || privacy === void 0 ? void 0 : privacy.version,
                productMarketingOptIn: productMarketingOptIn,
            };
        },
    };
}
function initEmptyOptIn() {
    return {
        callOptIn: false,
        emailOptIn: false,
        postalMailOptIn: false,
        pushNotificationOptIn: false,
        smsOptIn: false,
    };
}
function getTranslatedSubConsent(subcategory) {
    var translations = {
        EMAIL: 'sign-up-marketing-preferences.email.text',
        SMS: 'sign-up-marketing-preferences.sms.text',
        PHONE: 'sign-up-marketing-preferences.call.text',
        POSTALMAIL: 'sign-up-marketing-preferences.postal-mail.text',
        PUSH_NOTIFICATION: 'sign-up-marketing-preferences.push-notification.text',
    };
    return (translate(translations[subcategory]) || capitalizeFirstLetterOnly(subcategory));
}
function getTranslatedCategoryHeader(category) {
    var headers = {
        casino: 'sign-up-marketing-preferences.casino.title',
        sports: 'sign-up-marketing-preferences.sports.title',
    };
    return translate(headers[category]) || capitalizeFirstLetterOnly(category);
}
function capitalizeFirstLetterOnly(title) {
    var lower = title.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}

export { nestedConsents };
